<template>
  <mymodal ref="theModal" :need-header="true" :need-footer="false" :size="'large'">
    <div slot="title">{{'History Detail'|translate}}</div>
    <div slot="body" v-if="item">
      <p class="mt20">
        <label class="block">{{'Action name'|translate}}</label>
        {{item.action_name}}
      </p>
      <p class="mt20">
        <label class="block">{{'Start date'|translate}}</label>
        {{ item.start_date | moment("DD/MM/YYYY") }}
      </p>
      <p class="mt20">
        <label class="block">{{'Done by'|translate}}</label>
        {{item.done_by}}
      </p>
      <p class="mt20">
        <label class="block">{{'Description'|translate}}</label>
        {{item.description}}
      </p>
      <p class="mt20">
        <label class="block">{{'Explanation'|translate}}</label>
        {{item.explanation}}
      </p>
      <list-history-photo :item="item"></list-history-photo>
    </div>
  </mymodal>
</template>
<script>
import mymodal from "@/components/elements/Modal";
import ListHistoryPhoto from "@/components/Cultivation/ListHistoryPhoto";
import Utils from "@/helpers/utils";
//import GoogleAutocomplete from 'google-autocomplete-vue';
export default {
  name: "FormHistory",
  components: {
    mymodal,
    ListHistoryPhoto
  },
  props: ["pass_data"],
  data() {
    return {
      item: null
    };
  },
  created() {
    // clone from original params
  },
  methods: {
    open() {
      this.$refs.theModal.open();
      this.item = JSON.parse(JSON.stringify(this.pass_data));
      
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Cultivation/HistoryDetail.vue